(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Pv', Pv);

    Pv.$inject = ['$resource'];

    function Pv ($resource) {
        var resourceUrl =  'api/pvs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
